import * as ReactService from "@intech/react-service";
import { CalendarioPagamentoEntidade } from "../entidades/CalendarioPagamentoEntidade";

class CalendarioPagamento extends ReactService.BaseService {
  constructor() {
    super("CalendarioPagamento");
  }

  BuscarPorPlano = (cdplano: string) =>
    this.CreateRequest<CalendarioPagamentoEntidade[]>(ReactService.RequestType.GET, `BuscarPorPlano/${cdplano}`);

}

export const CalendarioPagamentoService = new CalendarioPagamento();
